export default {"src":"/_next/static/media/Female-11.1ba62788.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};